import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useEffect } from "react";
import { fetchVendors, Vendor } from "../vendorsSlice";
import { VendorCard } from "./VendorCard";
import { VendorListTools } from "./VendorListTools";
import { useAuth } from "react-oidc-context";

import styled from 'styled-components'
import { Loading } from "../../shared/components/Loading";

export const Wrapper = styled.div`
  display: grid;
  padding-top: 3rem;
  width: 100%;
  max-width: 1640px;
`

export const VendorsList = () => {
  const dispatch = useAppDispatch();
  const vendorsstate = useAppSelector(state => state.vendorsstate);
  const auth = useAuth();

  useEffect(() => {
    if (vendorsstate.status === 'idle' || !vendorsstate.vendors || vendorsstate.vendors.length === 0) {
      dispatch(fetchVendors());
    }
  }, [dispatch])

  const vendors = vendorsstate.vendors.slice().sort((a, b) => a.vendorOrder - b.vendorOrder);

  return (vendorsstate.status === 'idle' || vendorsstate.status === 'pending') ? (
    <Loading centre />
  ) : (
    <Wrapper>
      <div className='lr-padded-container center-text'>
        <h1 style={{ marginBottom: '25px' }}>Makers Market</h1>
        <hr style={{ maxWidth: '200px', marginInline: 'auto' }} />
      </div>

      {auth.isAuthenticated && <VendorListTools />}

      <div className="lr-padded-container">
        {vendors.length === 0 ? (
          <p className="center-text">No vendors listed yet.</p>
        ) : (
          vendors.map((vendor: Vendor) => <VendorCard key={vendor.id} vendor={vendor} />)
        )}
      </div>
    </Wrapper>
  )
}
